import React from 'react';

import Switch from 'components/DesignSystem/Switch';
import ActionButton from 'components/ActionButton';
import { WindxPainelOption } from 'types/Windx/Models/windxPainelOption';
import { categoriaLabel, telasLabel } from 'helper/Windx/modelLabels';

import './index.scss';

export interface ModelCardProps {
  model: WindxPainelOption;
  isPending: boolean;
  onEdit: (model: WindxPainelOption) => void;
  onToggleAtivo: (model: WindxPainelOption) => void;
  onDelete: (model: WindxPainelOption) => void;
}

export default function ModelCard({
  model, isPending, onEdit, onToggleAtivo, onDelete,
}: ModelCardProps) {
  return (
    <div className="models-mobile-card" data-testid={`windx-modelo-card-${model.id}`}>
      <div className="models-mobile-card-summary">
        <div className="models-mobile-card-heading">
          <p className="models-mobile-card-title">{model.config.label}</p>
          <span className="models-mobile-card-code">{model.codigo}</span>
        </div>
        <span className="models-mobile-card-id">{`#${model.id}`}</span>
      </div>

      <dl className="models-mobile-card-meta">
        <div>
          <dt>Telas</dt>
          <dd>{telasLabel(model.telas)}</dd>
        </div>
        <div>
          <dt>Categoria</dt>
          <dd>{categoriaLabel(model.categoria)}</dd>
        </div>
        <div>
          <dt>Ordem</dt>
          <dd>{model.order_by}</dd>
        </div>
      </dl>

      <div className="models-mobile-card-actions">
        <div className="models-mobile-card-toggle">
          <Switch
            className="ds-switch-pill"
            checked={model.ativo}
            disabled={isPending}
            onChange={() => onToggleAtivo(model)}
            aria-label={`Visibilidade do modelo ${model.codigo}`}
            data-testid={`windx-modelo-switch-${model.id}`}
          />
          <span className={model.ativo ? 'models-mobile-card-on' : 'models-mobile-card-off'}>
            {model.ativo ? 'Exibido' : 'Oculto'}
          </span>
        </div>
        <div className="models-mobile-card-buttons">
          <ActionButton
            icon="edit"
            tooltipText="Editar modelo"
            disabled={isPending}
            onClick={() => onEdit(model)}
            id={`edit-windx-modelo-${model.id}`}
          />
          <ActionButton
            icon="trash"
            tooltipText="Excluir modelo"
            disabled={isPending}
            onClick={() => onDelete(model)}
            id={`delete-windx-modelo-${model.id}`}
          />
        </div>
      </div>
    </div>
  );
}
